import type { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { useIsMobileVariant } from '@dhl-ui/components'
import { PageWithRefresh, type PageMenuItem } from '@dhl-ui/page'
import { type PageProps, Page as ReceiverPage } from '@dhl/receiver-page'
import { PromotionDialog } from '~/components/PromotionDialog.js'
import { useMenuItems } from './use-menu-items.js'
import { EndNode } from './EndNode.js'
import { HeaderContent } from './HeaderContent.js'

export const PortalMainPage: FC<PageProps> = ({ children, ...props }) => {
  const navigate = useNavigate()
  const isMobileVariant = useIsMobileVariant()

  const handleMenuSelect = (item: PageMenuItem) => {
    navigate(item.link)
  }

  const menuItems = useMenuItems()

  return (
    <ReceiverPage
      sideMenu={
        !isMobileVariant ? (
          <PageWithRefresh.SideMenu items={menuItems} onSelect={handleMenuSelect} endNode={<EndNode />} />
        ) : undefined
      }
      bottomMenu={
        isMobileVariant ? <PageWithRefresh.BottomMenu items={menuItems} onSelect={handleMenuSelect} /> : undefined
      }
      header={<PageWithRefresh.Header endNode={<HeaderContent />} />}
      endNode={<PromotionDialog />}
      {...props}
    >
      {children}
    </ReceiverPage>
  )
}
